/**
 * @generated SignedSource<<da567c7289672355bb471e11a8c1c096>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActivityVerb = "FINISHED" | "IN_PROGRESS" | "WISHLIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MoviePageMarkHistory$data = {
  readonly mark_history: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly comment: string;
        readonly created_at: string;
        readonly id: string;
        readonly rating: number | null;
        readonly verb: ActivityVerb;
      };
    } | null> | null;
  } | null;
  readonly " $fragmentType": "MoviePageMarkHistory";
};
export type MoviePageMarkHistory$key = {
  readonly " $data"?: MoviePageMarkHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoviePageMarkHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "mark_history"
        ]
      }
    ]
  },
  "name": "MoviePageMarkHistory",
  "selections": [
    {
      "alias": "mark_history",
      "args": null,
      "concreteType": "ActivityConnection",
      "kind": "LinkedField",
      "name": "__MoviePageMarkHistory_mark_history_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Activity",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "verb",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rating",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "created_at",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Movie",
  "abstractKey": null
};

(node as any).hash = "b9b44c4ed84abb27f0b62e37483ebc97";

export default node;
